import { z } from 'zod';

import {
  AddOnService,
  PeerPilotEligibility,
} from './resources/extended-submission-info';

export type DownloadState = z.infer<typeof DownloadState>;
export const DownloadState = z.enum([
  'PENDING',
  'READY',
  'EXPIRED',
  'NOT_AVAILABLE',
]);

export type PaymentStatus = z.infer<typeof PaymentStatus>;
export const PaymentStatus = z.enum([
  'REFUNDED',
  'VOUCHER_PAID',
  'CREDIT_CARD_PAID',
  'FREE',
  'REUPLOAD_OF_PURCHASED_DOCUMENT',
  'UNPAID',
]);

export type SubmissionState =
  | {
      name: 'UNKNOWN';
      generatingDocument: boolean;
      finalPrice: string;
      currency: string;
      fileUploadDate?: string;
      tittle?: string;
      salePrice?: string;
      salePriceOriginal?: number;
      finalPriceOriginal?: number;
      discountPrice?: string;
      discountApplied?: boolean;
      orderId?: string;
      addOnServiceList?: AddOnService[];
      peerPilotEligibility?: PeerPilotEligibility;
    }
  | {
      name: 'VOUCHER_PENDING';
      generatingDocument: boolean;
      fileUploadDate?: string;
      tittle?: string;
      peerPilotEligibility?: PeerPilotEligibility;
    }
  | {
      name: 'PROCESSING_FAILED';
      peerPilotEligibility?: PeerPilotEligibility;
    }
  | {
      name: 'PROCESSING_FAILED_RETRYING';
      peerPilotEligibility?: PeerPilotEligibility;
    }
  | {
      name: 'REQUIRES_PAYMENT';
      editedFileName: string;
      finalPrice: string;
      paymentStatus: PaymentStatus;
      currency: string;
      fileUploadDate?: string;
      tittle?: string;
      salePrice?: string;

      salePriceOriginal?: number;
      finalPriceOriginal?: number;
      discountPrice?: string;
      discountApplied?: boolean;
      orderId?: string;
      addOnServiceList?: AddOnService[];
      peerPilotEligibility?: PeerPilotEligibility;
    }
  | {
      name: 'VOUCHER_READY';
      editedFileName: string;
      voucherCode: string;
      fileUploadDate?: string;
      tittle?: string;
      peerPilotEligibility?: PeerPilotEligibility;
    }
  | {
      name: PaymentStatus;
      downloadAvailableDays: number;
      downloadState: Exclude<DownloadState, 'EXPIRED' | 'NOT_AVAILABLE'>;
      editedFileName: string;
      fileUploadDate?: string;
      finalPrice?: string;
      currency?: string;
      tittle?: string;
      salePrice?: string;

      salePriceOriginal?: number;
      finalPriceOriginal?: number;
      discountPrice?: string;
      discountApplied?: boolean;
      orderId?: string;
      addOnServiceList?: AddOnService[];
      peerPilotEligibility?: PeerPilotEligibility;
    }
  | {
      name: 'NO_ISSUES';
      peerPilotEligibility?: PeerPilotEligibility;
      editedFileName?: string;
      tittle?: string;
    }
  | {
      name: 'EXPIRED';
      downloadAvailableDays: number;
      fileUploadDate?: string;
      tittle?: string;
      peerPilotEligibility?: PeerPilotEligibility;
    }
  | {
      name: 'ERROR';
      peerPilotEligibility?: PeerPilotEligibility;
    }
  | {
      name: 'ERROR_RETRYING';
      peerPilotEligibility?: PeerPilotEligibility;
    }
  | {
      name: 'SAMPLE';
      finalPrice: string;
      currency: string;
      fileUploadDate?: string;
      tittle?: string;
      salePrice?: string;

      salePriceOriginal?: number;
      finalPriceOriginal?: number;
      discountPrice?: string;
      discountApplied?: boolean;
      orderId?: string;
      addOnServiceList?: AddOnService[];
      peerPilotEligibility?: PeerPilotEligibility;
    };
